import axios from "axios";

export const API_URL =
  process.env.REACT_APP_API_URL || "https://sp-hygiene.com/api";

export const createPayment = async (paymentData: any, refreshToken: Function, retry=false): Promise<string|{formToken: string, orderId: string}> => {
  const token = localStorage.getItem('sph-access');
  const {amount, billingAddressId, deliveryAddressId, deliveryMode} = paymentData;

  try {
    const body = {
      amount: +((+amount.toFixed(2) * 100).toFixed()),
      currency: "EUR",
      billingAddressId,
      deliveryAddressId,
      deliveryMode,
    };

    const result = await axios.post(`${API_URL}/purchase/createPayment`, body, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return result.data;
  } catch (error: any) {
    if (error.status === 401 && !retry) {
      try {
        await refreshToken();
        return createPayment(paymentData, refreshToken, true);
      } catch (err) {
        return (error.response?.data || "Erreur inconnue");
      }
    }
    return (error.response?.data || "Erreur inconnue");
  }
};

export const validatePayment = async (validatePaymentData: any, setMessage: Function, refreshToken: Function, successRedirection: Function, retry=false): Promise<boolean> => {
  const token = localStorage.getItem('sph-access');

  try {
    await axios.post(`${API_URL}/purchase/validatePayment`, validatePaymentData, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    setMessage('Payment successful! Redirection in progress…');
    successRedirection();
    return false;
  } catch (error: any) {
    if (error.status === 401 && !retry) {
      try {
        await refreshToken();
        validatePayment(validatePaymentData, setMessage, refreshToken, successRedirection, true);
      } catch (err) {
        return false;
      }
    }
    return false;
  }
}
